<template>
  <div>
    <section class="ayuda body-container">
      <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary">
          <v-card-text>
            <div class="loadTitle">
              <img :src="images.logo" /> <label>Cargando...</label>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div class="ayuda-container">
        <div>
          <div class="ayuda-header">
            <div class="ayuda-title">
              <h2><span class="bricsa-square"></span>Ayuda</h2>
            </div>
          </div>
          <div class="ayuda-tabs container">
            <b-button
              @click="helpType = 'ticket'"
              class="ayuda-tabs__item"
              :class="helpType == 'ticket' ? 'isActive' : ''"
              ><font-awesome-icon :icon="['fa', 'plus-square']" />Nueva
              solicitud</b-button
            >
            <b-button
              @click="helpType = 'soliList'"
              class="ayuda-tabs__item"
              :class="helpType == 'soliList' ? 'isActive' : ''"
              ><font-awesome-icon :icon="['fa', 'file-alt']" />Mis
              Solicitudes</b-button
            >
            <b-button
              @click="helpType = 'faq'"
              class="ayuda-tabs__item"
              :class="helpType == 'faq' ? 'isActive' : ''"
              ><font-awesome-icon :icon="['fa', 'question']" />Preguntas
              Frecuentes</b-button
            >
            <b-button
              v-if="haytips"
              @click="helpType = 'tyc'"
              class="ayuda-tabs__item"
              :class="helpType == 'tyc' ? 'isActive' : ''"
              ><font-awesome-icon :icon="['fa', 'lightbulb']" />Tips y
              Consejos</b-button
            >
          </div>
        </div>

        <div v-if="helpType == 'ticket'" class="solicitud container">
          <div
            role="alert"
            v-show="errors.length > 0"
            v-bind:class="{ show: errors.length }"
            class="alert alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>
          <v-alert v-show="form_show" outlined :type="result_type" text>
            Gracias. Hemos recibido correctamente su solicitud.
          </v-alert>
          <b-form
            class="form-signinx d-flex align-items-stretch flex-column"
            autocomplete="off"
            @submit="onSubmit"
          >
            <div class="row">
              <div class="form-group col-md-12">
                <b-form-input
                  type="text"
                  placeholder="Motivo"
                  v-model="$v.form.motivo.$model"
                  :state="validateState('motivo')"
                  aria-describedby="info-motivo-mensaje-validacion"
                ></b-form-input>
                <b-form-invalid-feedback id="info-motivo-mensaje-validacion"
                  >Motivo es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-select
                  placeholder="Propiedad"
                  v-model="$v.form.negocio.$model"
                  :state="validateState('negocio')"
                  aria-describedby="info-negocio-mensaje-validacion"
                >
                  <option
                    v-for="project in proyectos"
                    :value="project"
                    :key="project.negocio"
                  >
                    {{ project.productoPrincipal.tipo }}
                    {{ project.productoPrincipal.numero }} -
                    {{ project.proyecto }}
                  </option>
                </b-form-select>
                <b-form-invalid-feedback id="info-negocio-mensaje-validacion"
                  >Propiedad es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-textarea
                  placeholder="Descripción"
                  v-model="$v.form.detalle.$model"
                  :state="validateState('detalle')"
                  aria-describedby="info-desc-mensaje-validacion"
                ></b-form-textarea>
                <b-form-invalid-feedback id="info-desc-mensaje-validacion"
                  >Descripción es obligatorio.</b-form-invalid-feedback
                >
              </div>
            </div>

            <b-button
              ref="kt_login_signin_submit"
              @click="onSubmit"
              class="btn btn-primary align-self-center"
              >ENVIAR</b-button
            >
          </b-form>
        </div>
        <!-- Si solicitudes seleccionado se muestra lo siguiente -->
        <div v-if="helpType == 'soliList'" class="solicitudes">
          <div class="solicitudes-title">
            <h2><span class="bricsa-square"></span>Mis Solicitudes</h2>
          </div>
          <div class="solicitudes-content">
            <div
              class="solicitudes-content__item"
              v-for="(soli, index) in solicitudes.solicitudes"
              :key="index" @click="verDetalle(soli)"
            >
              <div class="solicitudes-item__title" >
                <h3>
                  <span
                    class="bricsa-square"
                    :class="[
                      soli.estado == 'Pendiente' ? 'soliRed' : '',
                      soli.estado == '' ? 'soliOrange' : '',
                      soli.estado == '' ? 'soliBlue' : '',
                    ]"
                  ></span
                  >N° de Solicitud: {{ soli.idSolicitudSCI }}
                </h3>
                <small>{{ soli.estado }}</small>
              </div>
              <div class="solicitudes-item__info">
                <p>{{ soli.detalle }}</p>
              </div>
            </div>
            <div v-if="solicitudes.solicitudes.length==0" class="alert alert-danger">No existen solicitudes.</div>
            <!--div class="solicitudes-content__item" @click="soliOpen = true">
              <div class="solicitudes-item__title">
                <h3>
                  <span class="bricsa-square soliRed"></span>N° de Solicitud:
                  9344567
                </h3>
                <small>Aplica</small>
              </div>
              <div class="solicitudes-item__info">
                <p>Probando la solicitud</p>
              </div>
            </div-->  
            <b-modal v-model="soliOpen" :width="440" scroll="keep" class="soliInfo__modal">
              <div class="card">
                <header class="modal-card-head">
                  <p class="modal-card-title">N° de Solicitud: {{solicitudActual.idSolicitudSCI}}</p>
                  <button
                    type="button"
                    class="delete"
                    @click="soliOpen = false"
                  />
                </header>
                <div class="card-content">
                  <div class="content" v-for="(req, index) in solicitudActual.requerimientos"
              :key="index" >
                    <div class="soliInfo__item">
                      <label>Estado</label>
                      <span>{{req.estado}}</span>
                    </div>
                    <div class="soliInfo__item">
                      <label>Aplica?</label>
                      <span>{{req.corresponde_reparar}}</span>
                    </div>
                    <div class="soliInfo__item">
                      <label>Fecha de agendamietno</label>
                      <span>{{req.fechaAgendamiento|formatDate}}</span>
                    </div>
                    <div class="soliInfo__item">
                      <label>Fecha de Cierre</label>
                      <span>{{req.fechaCierre|formatDate}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
          <section class="texto-legal">
            <div class="texto-legal__info">
              <p>
                Tus solicitudes aparecen en esta sección cuando nuestras
                ejecutivas lo validan y asignan para resolver. Podrás encontrar
                todos tus requerimientos y hacerle seguimiento del estado. En
                caso que tengas alguna duda adicional, puedes comunicarte con
                nuestras ejecutivas.
              </p>
            </div>
          </section>
        </div>
        <!-- Aquí termina la lista de solicitudes -->

        <!-- Empiezan las preguntas frecuentes -->
        <div v-if="helpType == 'faq'" class="FAQ">
          <div class="FAQ-title">
            <h2><span class="bricsa-square"></span>Preguntas frecuentes</h2>
          </div>
          <div class="FAQ-content">
            <b-collapse
              class="card property show"
              animation="slide"
              v-for="(faq, index) in preguntas"
              :key="index"
              :open="isOpen"
              @open="isOpen"
            >
              <template #trigger="props">
                <div class="card-header" role="button">
                  <p class="card-header-title">
                    {{ faq.title }}
                  </p>
                  <a class="card-header-icon">
                    <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
                    </b-icon>
                  </a>
                </div>
              </template>
              <div class="card-content">
                <div class="content">
                  {{ faq.respuesta }}
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
        <!-- Terminan las preguntas frecuentes -->
        <!-- Empiezan las preguntas frecuentes -->
        <div v-if="helpType == 'tyc'" class="TyC">
          <div class="TyC-title">
            <h2><span class="bricsa-square"></span>Tips</h2>
          </div>
          <div class="TyC-content">
            <b-carousel
              :arrow="arrow"
              :repeat="repeat"
              :has-drag="drag"
              :pause-info="false"
              icon-pack="fas"
              icon-prev="angle-left"
              icon-next="angle-right"
              :icon-size="iconSize"
            >
              <b-carousel-item v-for="(tip, i) in tips" :key="i">
                <section class="hero is-medium">
                  <div
                    class="has-text-centered tip-item"
                    @click="isCardModalActive = true"
                  >
                    <img :src="tip.image" />
                    <h3 class="title">{{ tip.title }}</h3>
                  </div>
                </section>
                <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
                  <div class="card">
                    <div class="card-content">
                      <h3>
                        <span class="bricsa-square"></span>{{ tip.title }}
                      </h3>
                      <p>
                        {{ tip.desc }}
                      </p>
                    </div>
                  </div>
                </b-modal>
              </b-carousel-item>
            </b-carousel>
            <div class="TyC-title">
              <h2><span class="bricsa-square"></span>Videos</h2>
            </div>
            <div class="TyC-videos">
              <b-carousel
                v-model="values"
                :arrow="arrow"
                :arrow-hover="arrowHover"
                :items-to-show="perList"
                :items-to-list="increment"
                :repeat="repeat"
                :has-drag="drag"
                :pause-info="false"
                icon-pack="fa"
                icon-prev="angle-left"
                icon-next="angle-right"
                :icon-size="iconSize"
              >
                <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                  <section class="hero is-medium">
                    <div class="has-text-centered">
                      <iframe
                        :src="carousel.url"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                      <h1 class="title">{{ carousel.title }}</h1>
                    </div>
                  </section>
                </b-carousel-item>
              </b-carousel>
            </div>
          </div>
        </div>
        <!-- Terminan las preguntas frecuentes -->
      </div>
    </section>
    <section class="adBanner">
      <img :src="images.family" alt="" />
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";
import moment from "moment";
import { GET_PROJECTS } from "@/core/services/store/proyecto.module";
import {
  CREATE_SOLICITUD,
  GET_SOLICITUDES,
} from "@/core/services/store/solicitud.module";
moment.locale("es");
export default {
  mixins: [validationMixin],
  name: "index",
  data() {
    return {
      solicitudActual:{},
      soliOpen: false,
      loading: true,
      images: {
        family: process.env.BASE_URL + "media/family.jpg",
        logo: process.env.BASE_URL + "media/logo.png",
      },
      form_show: false,
      result_type: "success",
      haytips: false,
      form: {
        motivo: "",

        negocio: "",
        detalle: "",
      },
      isCardModalActive: false,
      helpType: "soliList",
      isOpen: 0,

      preguntas: [
        {
          title:
            "¿Quién es el responsable de la venta y post venta, la constructora o la inmobiliaria?",
          respuesta:
            "BRICSA, es una empresa que gestiona y a la vez construye los proyectos inmobiliarios que desarrolla, lo cual es una garantía de compromiso con el producto final, sin embargo, es la Inmobiliaria la empresa que vende las propiedades y, por lo tanto, la responsable de entregar el servicio de post venta a los clientes.",
        },
        {
          title: "¿Cuáles son las etapas que tiene la compra de una casa?",
          respuesta:
            "La compra de una casa comienza desde el primer contacto establecido en la sala de ventas, en donde además de conocer el proyecto y las casas piloto, se puede efectuar una reserva por una determinada propiedad. El paso siguiente, es la firma de una promesa de compraventa, lo cual se realiza en la oficina de ventas ubicada en Coyancura 2283, piso 4, Providencia. Cuando su casa está lista para ser entregada, se firma la escritura de compraventa correspondiente, luego de la cual se puede hacer la entrega definitiva. Usted es dueño de su propiedad a partir del momento en que ésta queda inscrita a su nombre en el Conservador de Bienes Raíces.",
        },
        {
          title:
            "¿En qué tengo que fijarme al momento de recibir mi casa nueva?",
          respuesta:
            "Siempre puede haber detalles que el área de calidad y el Inspector de Entrega no detecta, por lo que es importante revisar bien su casa al momento de la entrega, ya que luego de una eventual mudanza puede haber deterioros involuntarios que posterior a la entrega no se podrán calificar como detalle constructivo.",
        },
        {
          title:
            "¿En qué puedo observar la calidad de las viviendas de BRICSA, empresa Brotec Icafal?",
          respuesta:
            "Desde el punto de vista constructivo, “calidad” es el cumplimiento sistemático de los estándares definidos. En este sentido, nuestra empresa pone énfasis en la calidad en todo el proceso constructivo, lo cual está certificado de acuerdo a la norma ISO-9001. A simple vista, la calidad sólo es observable en que las terminaciones son muy similares en todas las viviendas respecto a las de las casas pilotos, variando mínimamente en un rango aceptable de acuerdo a la norma.",
        },
        {
          title:
            "¿Por qué algunas cosas pueden ser diferentes entre mi casa y la casa piloto?",
          respuesta:
            "Las casas piloto son generalmente construidas al principio de cada proyecto, y en ocasiones algunas medidas menores pueden variar respecto de una etapa en particular, debido a mejoras introducidas por la oficina de arquitectura, sin embargo, lo usual es que se mantengan tal cual. Las especificaciones técnicas de terminaciones también en ocasiones varían entre una etapa y otra, ya sea porque se está introduciendo una mejora, o porque hay un cambio de proveedor. Estos cambios se intentan reflejar en las casas piloto, sin embargo, pueden producirse importantes diferencias entre las primeras etapas y lo que se está construyendo en el momento, especialmente en los proyectos más grandes que se extienden por varios años y miles de casas.",
        },
        {
          title: "¿Mi casa estará 100% perfecta al momento de recibirla?",
          respuesta:
            "No necesariamente. Pese a que nuestra empresa cuenta con certificación ISO-9001, que garantiza nuestros procesos en términos del cumplimiento de estándares predeterminados, toda la construcción es en definitiva un proceso semi-artesanal, con un importante componente humano de por medio, por lo cual es prácticamente imposible que quede todo perfecto. Para disminuir al máximo los detalles que una casa pueda presentar, BRICSA, ha incorporado siempre políticas de mantención y seguridad para sus trabajadores, de manera que el personal esté más comprometido con la empresa y sus clientes. Por otra parte, la empresa supervisa las diversas etapas del proceso constructivo a través de su área de calidad interna y de un certificador externo. Finalmente, la empresa dispone de un Inspector de Entrega, quien hace una revisión final antes de la entrega definitiva de las viviendas, y revisa las observaciones que se pudieron levantar en el momento de la pre-entrega según corresponda.",
        },
        {
          title: "¿Cómo se solicita un arreglo o reparación en garantía?",
          respuesta:
            "El procedimiento establecido consiste en el envío de una solicitud escrita, vía mail a clientes@bricsa.cl en la que se detallan los requerimientos del propietario y sus datos de contacto. Inmediatamente después de recibida la solicitud, se programa con el propietario una fecha de inspección, que es realizada por un Inspector de entrega, quien determina si los requerimientos solicitados corresponden a detalles constructivos en garantía, y luego programa los trabajos a realizar en una fecha próxima, en coordinación con los dueños de casa.",
        },
        {
          title:
            "¿Qué pasa si tengo una emergencia con el gas, agua o electricidad?",
          respuesta:
            "En casos de emergencia, basta con enviar un correo a clientes@bricsa.cl y se dará la respectiva prioridad para la visita de un especialista. Si la emergencia ocurre fuera del horario de trabajo (lunes a viernes de 8:30 a 17:30 horas), favor enviar un correo electrónico a clientes@bricsa.cl, indicando “Emergencia” en el asunto del mail y atenderemos su caso lo antes posible. Mientras su requerimiento es atendido, le sugerimos cortar el suministro de electricidad, agua o gas, según corresponda.",
        },
        {
          title: "¿Qué cubre la garantía de mi casa nueva?",
          respuesta:
            "La garantía de post venta que establece la Ley contempla los daños atribuibles a un vicio de la construcción, de los materiales o del terreno (fallas, errores o defectos).",
        },
        {
          title: "¿Cuánto dura la garantía de mi casa?",
          respuesta:
            "Los plazos máximos establecidos por la Ley para ejercer la garantía de post venta son de 10 años para fallas o defectos que afecten la estructura soportante del inmueble y 5 años para los casos de fallas o defectos en los elementos constructivos o en las instalaciones, a partir de la fecha de recepción municipal de la propiedad. Para las fallas o defectos que afecten a elementos de terminaciones o acabado de las obras, el plazo máximo es de 3 años a partir de la fecha de inscripción del inmueble en el Conservador de Bienes Raíces. Sin perjuicio de lo anterior, nuestros proveedores especializados en determinados suministros, contemplan diversos plazos de garantía, los cuales son debidamente informados al momento de la entrega de las viviendas.",
        },
        {
          title: "¿Qué cosas no cubre la garantía?",
          respuesta:
            "La garantía de post venta no cubre detalles constructivos, sino defectos en la construcción. En este sentido, la garantía de post venta no cubre desgastes de material, tales como alfombras, pisos flotantes, pinturas o papeles murales. Tampoco cubre abolladuras, hendiduras o desniveles que puedan ser atribuibles al uso normal de la vivienda o a accidentes involuntarios.",
        },
        {
          title: "¿Quién está a cargo de los espacios públicos en mi barrio?",
          respuesta:
            "Todos los espacios públicos de un proyecto inmobiliario, esto es, desde la reja exterior de su casa hacia fuera, son entregados a la municipalidad en el momento de la recepción municipal de las viviendas, por lo que le corresponde al municipio respectivo su cuidado y mantención. Sin embargo, muchas veces BRICSA, empresa Brotec Icafal, continúa dándole mantención por un tiempo a algunas plazas y jardines, a modo de deferencia con los vecinos y con la propia municipalidad.",
        },
        {
          title: "¿Quién es responsable de la seguridad en mi nuevo barrio?",
          respuesta:
            "La seguridad en su barrio depende única y exclusivamente de las autoridades competentes, tales como Carabineros de Chile y la unidad de seguridad ciudadana de la municipalidad correspondiente. Sin embargo, la experiencia dice que la mejor forma de lograr un mayor nivel de seguridad, es a través de la organización entre los vecinos de cada barrio, mediante programas de prevención organizados en conjunto con las autoridades.",
        },
        {
          title:
            "¿Puedo pedirle a un maestro de ustedes o a la empresa constructora que haga un trabajo particular en mi casa?",
          respuesta:
            "Nuestra empresa tiene como política no permitirles a los maestros realizar trabajos particulares en las viviendas, ya que de otra forma se puede prestar para malas prácticas, como por ejemplo en el uso de materiales. Por otra parte, nuestra empresa no tiene la estructura para la realización de trabajos individuales, ya que está enfocada a procesos de construcción masivos.",
        },
        {
          title:
            "¿Puedo instalar un servicio de telefonía, internet y/o televisión por cable diferente al propuesto por la inmobiliaria?",
          respuesta:
            "Sí puede. Cada propietario es libre de instalar el servicio autorizado que quiera en su vivienda, sin embargo, son las empresas proveedoras las que tienen como limitante el costo que le puede significar la instalación de un servicio determinado para una sola casa dentro de un barrio. Es por eso que como empresa siempre hemos tratado de seleccionar a los proveedores de servicios que ofrezcan las mejores condiciones, a través de productos competentes.",
        },
        {
          title: "¿Qué hago si quiero cambiar de gas natural a gas licuado?",
          respuesta:
            "Debe solicitarle a un instalador competente que realice la instalación del sistema de válvulas y regulador para la utilización de balones de gas licuado, además del cambio de los inyectores de todos los artefactos a gas de su propiedad. También puede solicitar a Metrogas que retire el medidor existente en su casa, ya que es de propiedad del proveedor de servicio.",
        },
      ],
      arrow: false,
      arrowHover: false,
      iconPack: "fa",
      iconPrev: "angle-left",
      iconNext: "angle-right",
      iconSize: "",
      drag: true,
      gray: false,
      opacity: false,
      values: 0,
      perList: 2,
      increment: 1,
      repeat: true,
      tips: [],
      carousels: [
        {
          url: "https://www.youtube.com/embed/Y8n68CxQ4tc",
        },
        {
          url: "https://www.youtube.com/embed/gN69mXMrLm0",
        },
      ],
    };
  },
  validations: {
    form: {
      motivo: {
        required,
        minLength: minLength(6),
      },
      negocio: {
        required,
      },
      detalle: {
        required,
        minLength: minLength(6),
      },
    },
  },
  mounted() {
    this.getProjects();
    this.getSolicitudes();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  methods: {
    verDetalle(solicitud){
      this.solicitudActual = solicitud;
      if(solicitud.requerimientos.length>0){
        this.soliOpen=true;
      }
    },
    info(value) {
      this.test = value;
    },
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    getSolicitudes() {
      this.$Progress.start();
      this.$store.dispatch(GET_SOLICITUDES, null).then(() => {
        this.$Progress.finish();
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        motivo: null,
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        console.log("hay error");
        return;
      }
      let negocio = parseInt(this.$v.form.negocio.$model.negocio);
      let motivo = this.$v.form.motivo.$model;
      let detalle = this.$v.form.detalle.$model;
      let proyecto =
        this.$v.form.negocio.$model.productoPrincipal.tipo +
        " " +
        this.$v.form.negocio.$model.productoPrincipal.numero +
        " " +
        this.$v.form.negocio.$model.proyecto;

      this.$store
        .dispatch(CREATE_SOLICITUD, {
          IdNegocio: negocio,
          Titulo: motivo,
          Detalle: detalle,
          idCliente: 0,
          numero: 0,
          proyecto: proyecto,
          idProyecto: 0,
          idSolicitud: 0,
          estado: "",
          token: "",
        })
        .then(() => {
          if (this.errors.length == 0) {
            this.form_show = true;
          }
        })
        .catch(() => {});
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.solicitud.errors,
      projects: (state) => state.proyecto.projects,
      solicitudes: (state) => state.solicitud.solicitudes,
      proyectos: function() {
        if (typeof this.projects.proyectos == "undefined") return [];
        console.log(
          "  +++ " +
            typeof this.projects.proyectos +
            " " +
            this.projects.proyectos
        );
        let elementos = this.projects.proyectos;
        elementos.forEach((item) => {
          item.productoPrincipal = item.productos.find((el) => {
            return el.esPrincipal == true ?? {};
          });
        });
        return elementos;
      },
    }),
  },
};
</script>

<style lang="scss" scoped>

.soliInfo__modal{
  .modal-card-title{
    font-weight: bold;
    font-size: 20px;
  }
  .soliInfo__item{
    display: grid;
    margin: 15px 0;
    label{
      font-weight: bold;
    }
  }
}

.container {
  padding: 3% 5% !important;
}
.ayuda {
  padding-top: 120px;
  .ayuda-container {
    display: grid;
    grid-template-columns: 30% 70%;
    @media screen and(max-width:1025px) {
      grid-template-columns: 100%;
    }
    .ayuda-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .ayuda-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      button {
        color: var(--bricsa-red);
        font-weight: bold;
        border: none;
        background: transparent;
        margin-right: 10px;
        &:focus,
        &:active {
          box-shadow: none;
          outline: none;
        }
      }
    }
    .ayuda-tabs {
      display: grid;
      grid-template-columns: 100%;
      justify-content: space-between;
      row-gap: 20px;
      @media screen and(max-width:1025px) {
        grid-template-columns: repeat(2, 49%);
      }
      .ayuda-tabs__item {
        font-size: 14px;
        padding: 10px;
        height: fit-content;
        font-weight: bold;
        border: none;
        border-radius: 0px;
        -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        color: var(--bricsa-skiblue);
      }
      .isActive {
        background-color: var(--bricsa-skiblue);
        color: #fff;
      }
    }
    .solicitud {
      display: grid;
      margin: 20px;
      padding: 20px 25px;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      button {
        width: 100%;
        justify-self: flex-end;
        background: var(--bricsa-red);
        border-radius: 0px;
        color: #fff;
        margin-top: 10px;
        border-color: transparent;
      }
    }
    .solicitudes {
      .solicitudes-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .solicitudes-content {
        padding: 3% 5%;
        display: grid;
        grid-template-columns: repeat(3, 31%);
        justify-content: space-between;
        row-gap: 10px;
        @media screen and (max-width: 1025px) {
          grid-template-columns: 100%;
        }
        .solicitudes-content__item {
          padding-bottom: 10px;
          -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
          -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
          box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
          .solicitudes-item__title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px 10px 0;
            h3 {
              width: fit-content;
              color: #7e7e7e;
              font-weight: bold;
              text-align: left;
              display: flex;
              align-items: baseline;
              margin: 0;
              padding-right: 10px;
              span {
                display: block;
                width: 10px;
                height: 10px;
                margin-right: 5px;
                background: var(--bricsa-red);
              }
              .soliRed {
                background-color: var(--bricsa-red);
              }
              .soliOrange {
                background-color: var(--bricsa-orange);
              }
              .soliBlue {
                background-color: var(--bricsa-blue);
              }
            }
            small {
              color: #707070;
              font-size: 12px;
            }
          }
          .solicitudes-item__info {
            p {
              padding: 10px;
              color: #7e7e7e;
              font-size: 12px;
              text-align: left;
              overflow: hidden;
              height: calc(1.3rem * 3);
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .texto-legal {
        margin-top: 20px;
        padding: 20px;
        background: #cbcbcb;
        .texto-legal__info {
          p {
            font-style: italic;
          }
        }
      }
    }
    .FAQ {
      .FAQ-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .FAQ-content {
        padding: 3% 5%;
        display: grid;
        grid-template-columns: 100%;
        justify-content: space-between;
        row-gap: 10px;
        @media screen and (max-width: 1025px) {
        }
        .card-header {
          padding: 10px;
        }
        .card-content {
          text-align: left;
          font-size: 12px;
          color: #707070;
          .content {
            padding-top: 0;
          }
        }
      }
    }
    .TyC {
      .TyC-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .TyC-content {
        .carousel-list {
          box-shadow: none;
        }
        .tip-item {
          height: 150px;
          display: grid;
          grid-template-columns: 100%;
          justify-content: center;
          align-items: center;
          img {
            width: 100%;
            height: 150px;
            object-fit: cover;
          }
          h3 {
            background: rgba(0, 0, 0, 0.3);
            color: #fff;
            height: 100%;
            align-items: center;
            justify-content: center;
            display: flex;
          }
          img,
          h3 {
            grid-column: 1/2;
            grid-row: 1/2;
          }
        }
      }
      .TyC-videos {
        iframe {
          width: 100%;
          height: 240px;
        }
      }
    }
  }
}
.modal {
  h3 {
    color: #707070;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin: 10px;
    margin-left: 0;
    display: flex;
    align-items: baseline;
    span {
      display: block;
      width: 15px;
      height: 15px;
      margin-right: 5px;
      background: var(--bricsa-red);
    }
  }
  p {
    text-align: left;
    font-size: 14px;
    color: var(--bricsa-grey);
  }
}
.adBanner {
  width: 100%;
  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    object-position: center 30%;
    @media screen and(max-width:1025px) {
      height: 150px;
    }
  }
}
</style>
